module.exports = __webpack_public_path__ + "img/australia-fw.b341e9b.png";